// extracted by mini-css-extract-plugin
export default {"Heading":"pmQ4Z9Ov"};